import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/graphql-mesh-gateway/graphql-mesh-gateway/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "upgrade-versions"
    }}>{`Upgrade versions`}</h1>
    <p>{`This page lists breaking changes between versions of API Mesh for Adobe Developer App Builder. For a list of new features and resolved issues, refer to the `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`release notes`}</a>{`.`}</p>
    <h2 {...{
      "id": "software-updates"
    }}>{`Software updates`}</h2>
    <p><inlineCode parentName="p">{`nvm`}</inlineCode>{` 18 is required for API Mesh.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Update `}<inlineCode parentName="p">{`nvm`}</inlineCode>{` to version 18. The following command shows one way to do this:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`nvm use 18
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Update the API Mesh plugin.`}</p>
        <p parentName="li">{` To update Adobe I/O and all registered plugins, run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`aio update
`}</code></pre>
        <p parentName="li">{`To update the API Mesh plugin only, run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`aio plugins:install @adobe/aio-cli-plugin-api-mesh
`}</code></pre>
      </li>
    </ol>
    <p>{`If you encounter any issues installing the plugin, try uninstalling any existing plugins first by running `}<inlineCode parentName="p">{`aio plugins:uninstall`}</inlineCode>{`. The `}<inlineCode parentName="p">{`aio plugins`}</inlineCode>{` command will list any installed plugins.`}</p>
    <p>{`See our `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@adobe/aio-cli-plugin-api-mesh"
      }}>{`NPM page`}</a>{` or `}<a parentName="p" {...{
        "href": "../basic/index.md#configure-your-environment"
      }}>{`Getting Started`}</a>{` for more information.`}</p>
    <h3 {...{
      "id": "mesh-create-and-update-time"
    }}>{`Mesh create and update time`}</h3>
    <p>{`While most `}<a parentName="p" {...{
        "href": "../advanced/index.md#aio-api-meshcreate"
      }}>{`create`}</a>{` and `}<a parentName="p" {...{
        "href": "../advanced/index.md#aio-api-meshupdate"
      }}>{`update`}</a>{` commands will take a few seconds, complex meshes and meshes with several sources will take a few minutes to fully provision and propagate.`}</p>
    <p>{`To check the status of your mesh, use the `}<a parentName="p" {...{
        "href": "../advanced/index.md#aio-api-meshstatus"
      }}><inlineCode parentName="a">{`aio api-mesh:status`}</inlineCode>{` command`}</a>{`, which allows you to view where your mesh is in the provisioning process.`}</p>
    <p>{`Additionally, due to our new asynchronous architecture, the create/update commands now add your mesh to a queue where it waits to be processed, which means you will no longer receive an error if your mesh fails to create/update. We have added the `}<a parentName="p" {...{
        "href": "../advanced/index.md#aio-api-meshstatus"
      }}><inlineCode parentName="a">{`aio api-mesh:status`}</inlineCode>{` command`}</a>{` to allow you to check the processing status of your mesh and see any errors that occurred during creating/updating.`}</p>
    {
      /* 
      ### Update existing meshes
      API Mesh now runs on updated versions of GraphQL Mesh [handlers](../basic/handlers/index.md) and [transforms](../basic/transforms/index.md). To move to the new codebase and enable these upgrades, update your existing meshes.
      1. [Select the workspace](work-with-mesh.md#select-a-project-or-workspace) that contains the mesh you want to update.
      1. [Retrieve](work-with-mesh.md#retrieve-a-previously-created-meshid-or-mesh-endpoint-url) your previously created mesh by running the following [`get` command](../advanced/index.md#aio-api-meshget).
          ```bash
         aio api-mesh:get download.json
         ```
        This command creates a file named `download.json` that contains a copy of the mesh from the selected workspace.
      1. Run the [update](create-mesh.md#update-an-existing-mesh) command and reference the previously created file.
          ```bash
         aio api-mesh:update download.json
         ```
          It can take a few minutes to fully provision and propagate your mesh. */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      